import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ElButton, ElPopover, ElIcon, ElDialog } from 'element-plus'
// @ts-ignore
import size from './size.vue'
import { ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'createDesing',
  setup(__props) {

const dialogVisible = ref(false)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "w-full h-40px flex items-center px-[15px] cursor-pointer",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogVisible.value = true))
    }, "创建设计"),
    _createVNode(_unref(ElDialog), {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
      title: "",
      width: "430",
      top: "100px",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        _createVNode(size)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})